import { useEffect, useState } from "react";
import { connect } from "react-redux";
import Alert from "../../../components/Alert";
import Table from "../../../components/Table";
import Add from "../../../assets/svgs/add.svg";
import Edit from "../../../assets/svgs/edit.svg";
import { filter, find, get, minBy } from "lodash";
import Delete from "../../../assets/svgs/delete.svg";
import DeleteItem from "../../../components/DeleteItem";
import AddService from "../../../components/AddService";
import { Actions } from "../../../internals/app/Actions";
import AddServiceCategory from "../../../components/AddServiceCategory";
import CourseHeader from "../../../components/CourseHeader";
import AddCourseCategory from "../../../components/AddCourseCategory";

const tableHeader = ["CATEGORY", "SERVICES", "MIN PRICE", "ACTIONS"];

const CourseView = (props: any) => {
  const { alertStatus, openAlertBox, updateCategory, category, fetchCategories, selectedShop, courseCategories } = props;
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [tableData, setTableData] = useState<Array<any>>([]);
  const [selectedService, setSelectedService] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [isOpenDelete, setIsOpenDelete] = useState<boolean>(false);
  const [isOpenService, setIsOpenService] = useState<boolean>(false);

  useEffect(() => {
    if (selectedShop?.shopId) {
      fetchCategories(selectedShop.shopId);
    }
  }, [selectedShop]);

  useEffect(() => {
    if (courseCategories) {
      const tableData = getData(courseCategories);
      setTableData(tableData);
    }
  }, [courseCategories]);

  // useEffect(() => {
  //   if (category.categories) {
  //     const tableData = getData(category.categories);
  //     setTableData(tableData);
  //   }
  // }, [category, alertStatus]);

  const getData = (data: any) => {
    return data.map((item: any) => {
      // const minService = minBy(item.services, "price");
      return {
        id: item.cId,
        CATEGORY: item.title,
        services: [],
        ACTIONS: [Add, Edit, Delete],
        SERVICES: '-',
        "MIN PRICE": '',
      };
    });
  };

  const onClickItem = (data: any, index: number) => {
    const value = find(
      category.categories,
      (category) => category.id === data.id
    );
    setSelectedCategory(value);
    if (index === 0) {
      setSelectedService(null);
      toggleService();
    } else if (index === 1) {
      toggleCategory();
    } else if (index === 2) {
      toggleDelete();
    }
  };

  const toggleDelete = () => {
    setIsOpenDelete(!isOpenDelete);
  };

  const toggleCategory = () => {
    setIsOpen(!isOpen);
  };

  const toggleService = () => {
    setIsOpenService(!isOpenService);
  };

  const onDeleteCategory = (data: any) => {
    const values = filter(
      category.categories,
      (category: any) => category.id !== data.id
    );
    category.categories = [...values];
    updateCategory(category, "DELETE");
    toggleDelete();
  };

  const onClickService = (serviceData: any, categoryData: any) => {
    const param = find(
      category.categories,
      (data: any) => data.id === categoryData.id
    );
    setSelectedService(serviceData);
    setSelectedCategory(param);
    toggleService();
  };

  return (
    <div className="flex flex-col w-full p-6 justify-start">
      <Alert
        alertStatus={alertStatus}
        onCloseAlert={(status: any) =>
          openAlertBox(status, false, alertStatus.successStatus)
        }
      />
      <div className="pb-6">
        <CourseHeader
          openCategory={() => {
            setSelectedCategory(null);
            toggleCategory();
          }}
        />
      </div>
      <Table
        onClickItem={onClickItem}
        {...{ tableHeader, tableData, type: "SERVICE" }}
        onClickService={(service: any, category: any) =>
          onClickService(service, category)
        }
      />
      {isOpen && (
        <AddCourseCategory
          isOpen={isOpen}
          selectedCategory={selectedCategory}
          closeModal={() => toggleCategory()}
        />
      )}
      <AddService
        isOpen={isOpenService}
        selectedService={selectedService}
        closeModal={() => toggleService()}
        selectedCategory={selectedCategory}
      />
      <DeleteItem
        isOpen={isOpenDelete}
        closeModal={() => toggleDelete()}
        onDelete={() => onDeleteCategory(selectedCategory)}
      />
    </div>
  );
};

export default connect(
  (state: any) => ({
    courseCategories: state.course.get("courseCategories"),
    category: state.service.get("category"),
    categories: state.product.get("categories"),
    alertStatus: state.common.get("alertStatus"),
    employeeList: state.employee.get("employeeList"),
    selectedShop: state.dashboard.get('selectedShop'),
  }),
  {
    openAlertBox: Actions.common.openAlertBox,
    updateCategory: Actions.service.updateCategory,
    fetchCategories: Actions.course.fetchCategories,
  }
)(CourseView);
